import React from 'react';
import { isFavoriteMarket, useFavoriteMarkets, useFavoriteMarketsDispatch } from './FavoriteMarketsProvider';
import { classIf } from '../../data/utils/classIf';

export default function FavoriteButtonMarket(props) {
    const favoriteMarketsDispatch = useFavoriteMarketsDispatch();

    function handleClick(e) {
        e.stopPropagation();
        favoriteMarketsDispatch({
            type: 'toggle',
            bet: props.bet
        });
    }

    const favorites = useFavoriteMarkets();
    const toggled = isFavoriteMarket(props.bet);

    return (
        <>
        {props.bet?.hasOdds && 
            <div className={`xs_btnFavMarkets ${props.className} pin-toggle`} onClick={handleClick}>
                <i className={"bi bi-pin-fill rotate-45" + classIf(toggled, 'selected')}></i>
            </div>
        }
        </>
         
    );
}
